import { Component, EventEmitter, Output } from '@angular/core'
import { EluxButton, EluxModal } from '@elxjs/ui'

@Component({
  selector: 'app-unsaved-modal',
  standalone: true,
  imports: [EluxModal, EluxButton],
  templateUrl: './unsaved-modal.component.html',
  styleUrls: ['./unsaved-modal.component.scss'],
})
export class UnsavedModalComponent {
  @Output() confirm = new EventEmitter<void>()
  @Output() cancel = new EventEmitter<void>()
}
